import ExclamationSign from '@svenskaspelab/ui/react/icons/ExclamationSign';

export const endMessage = {
  icon: <ExclamationSign />,
  title: 'Du har blivit utloggad',
  description: 'Den maximala tiden du kan vara inloggad är 24 timmar',
  buttons: {
    primary: {
      label: 'Okej',
    },
  },
};
